// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Send = function Send(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.23 9.063 2.57 3.746l12.407 5.317zm0 1.875h9.747L2.571 16.254l2.656-5.316zM1.744 1.352A1.25 1.25 0 0 0 .34 1.64c-.36.379-.441.95-.207 1.418L3.602 10 .133 16.942A1.25 1.25 0 0 0 .34 18.36c.36.382.918.496 1.403.293l17.5-7.5c.46-.196.757-.649.757-1.149s-.296-.953-.757-1.148l-17.5-7.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "send-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
